import React from "react";
import PropTypes from "prop-types";

import { styled } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import PresentationMarkerIcon from "@mui/icons-material/StarBorder";

const Entry = styled(ListItem)(({ theme }) => ({
  "&.MuiListItem-root": {
    padding: theme.spacing(1),
    cursor: "pointer",
    "& + &": {
      borderTop: `1px solid ${theme.palette.grayscale[3]}`
    },
    "li + &": {
      borderTop: `1px solid ${theme.palette.grayscale[3]}`
    },
    "& + li": {
      borderTop: `1px solid ${theme.palette.grayscale[3]}`
    },
    "&:hover": {
      backgroundColor: theme.palette.action.hover
    }
  }
}));

const EntryLabel = styled(ListItemText)(({ theme }) => ({
  "&.MuiListItemText-root": {
    hyphens: "auto"
  },
  "&.MuiListItemText-primary": {
    fontSize: theme.typography.pxToRem(16)
  },
  "&.MuiListItemText-secondary": {
    fontSize: theme.typography.pxToRem(16)
  }
}));

const EntryIcon = styled(ListItemIcon)(({ theme }) => ({
  "&.MuiListItemIcon-root": {
    minWidth: 0,
    padding: theme.spacing(1)
  }
}));

const Marker = styled(PresentationMarkerIcon)(() => ({
  "&.MuiIcon-root": {
    minHeight: "24px",
    maxHeight: "24px"
  }
}));

function PresentationMaterial({ material, onClickHandler, page }) {
  const materialTitle = material.name || material.title;
  const primaryLabel = material.Werk || materialTitle;
  let secondaryLabel = material.Werk ? materialTitle : null;

  if (material.type === "dlsUserMaterial") {
    secondaryLabel = "Eigene Materialien";
  }

  return (
    <Entry
      key={material._id}
      onClick={onClickHandler({
        id: material._id,
        page,
        renderType: material.renderType,
        type: material.type,
        material
      })}
    >
      <EntryIcon>
        <Marker />
      </EntryIcon>
      <EntryLabel primary={primaryLabel} secondary={secondaryLabel} />
    </Entry>
  );
}

PresentationMaterial.propTypes = {
  material: PropTypes.object.isRequired,
  onClickHandler: PropTypes.func.isRequired,
  page: PropTypes.number
};

export default PresentationMaterial;
